import React, { ReactNode } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

interface INavButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children: ReactNode;
}

const NavButton = ({ children, onClick }: INavButtonProps): JSX.Element => {
  return (
    <Button type="button" onClick={onClick}>
      {children}
    </Button>
  );
};

NavButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NavButton;

const Button = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:hover {
  }
`;
